import { useEffect, useRef, useState } from 'react'
import { keyboardKeys } from '@/constants'

export function useCloseOnQuit() {
  const ref = useRef<HTMLInputElement | null>(null)
  const [isOpened, setIsOpened] = useState(false)

  const handleMouseDown = (e: MouseEvent) => {
    if (ref?.current && !ref.current.contains(e.target as Node)) {
      setIsOpened(false)
    }
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === keyboardKeys.ESCAPE)
      setIsOpened(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('keydown', handleKeyDown)
    // return function to be called when unmount
    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  return { ref, isOpened, setIsOpened }
}
